import { render, staticRenderFns } from "./CenterInfo.vue?vue&type=template&id=5fca3b58&scoped=true&"
import script from "./CenterInfo.vue?vue&type=script&lang=js&"
export * from "./CenterInfo.vue?vue&type=script&lang=js&"
import style0 from "./CenterInfo.vue?vue&type=style&index=0&id=5fca3b58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fca3b58",
  null
  
)

export default component.exports